var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-rectangle",class:_vm.classes},[_c('svg-icon',{staticClass:"button-rectangle__icon",attrs:{"name":_vm.icon}}),_vm._v(" "),(_vm.$slots)?_c('span',{staticClass:"button-rectangle__label"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }